export enum UserItemKey {
  SETTINGS = 'settings',
  LOGOUT = 'logout',
}